<template>
  <b-field>
    <ckeditor
      ref="editor"
      :value="data"
      :config="editorConfig"
      :readOnly="readOnly"
      editorUrl="https://cdn.ckeditor.com/4.15.0/full-all/ckeditor.js"
      @input="onEditorInput"
    ></ckeditor>
  </b-field>
</template>

<script>
import CKEditor from 'ckeditor4-vue'

export default {
  name: 'Editor4',
  components: { ckeditor: CKEditor.component },

  model: {
    prop: 'data',
    event: 'change'
  },
  props: {
    data: String,
    area: String,
    ImageType: {
      type: String,
      default: 'Images'
    },
    height: {
      type: Number,
      default: 500
    },
    readOnly: Boolean
  },
  data() {
    return {
      editorConfig: {
        allowedContent: true,
        language: 'zh-tw',
        langCode: 'zh-tw',
        baseHref: `${process.env.VUE_APP_IMAGE_ROOT_URL}`,
        filebrowserBrowseUrl: `/ckfinder/ckfinder.html`,
        filebrowserImageBrowseUrl: `/ckfinder/ckfinder.html?type=${this.ImageType}`,
        filebrowserUploadUrl: '',
        filebrowserWindowWidth: '1000',
        filebrowserWindowHeight: '700',
        // startupPath: `Images:/Images/${this.area}`,
        // startupFolderExpanded: true,
        // rememberLastFolder: false,
        height: this.height,
        contentsCss:
          'https://fantasy-tours-production.s3.ap-northeast-1.amazonaws.com/Content/ckeditor/contents.css',
        removePlugins:
          'save,newpage,preview,print,exportpdf,templates,flash,language'
      }
    }
  },
  methods: {
    getData() {
      return this.$refs.editor.instance && this.$refs.editor.instance.getData()
    },
    onEditorInput(data) {
      this.$emit('change', data)
    }
  }
}
</script>
